export enum CharacterPartType {
  None = 0,
  Hair = 1,
  EyeBrow = 2,
  Eye = 3,
  Mouth = 4,
  Beard = 5,
  Hat = 6,
  Glasses = 7,
  Necklace = 8,
  Bracelet = 9,
  Shirt = 10,
  Pants = 11,
  Shoes = 12,
  Skin = 13,
  Gloves = 14,
  Misc = 15,
  Outfit = 16,
}

export interface CharacterPartDTO {
  name: string;
  characterPartId: string;
  characterPartType: CharacterPartType;
}
